import React from "react";
import { fullscreenSupported, toggleFullscreen, useFullscreen } from "./fullscreen";

// The ⛶ toggle: enter fullscreen, or leave it. Renders nothing where a page
// cannot go fullscreen (iPhone Safari). The caller supplies the class so it
// takes the look of whatever bar it sits in.
export default function FullscreenButton({ className }: { className?: string }) {
  const on = useFullscreen();
  if (!fullscreenSupported()) return null;
  return (
    <button
      type="button"
      className={className}
      onClick={toggleFullscreen}
      aria-label={on ? "Leave full screen" : "Full screen"}
      title={on ? "Leave full screen" : "Full screen"}
      aria-pressed={on}
    >
      {on ? (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
          <path d="M9 4v5H4M15 4v5h5M9 20v-5H4M15 20v-5h5" />
        </svg>
      ) : (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
          <path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5" />
        </svg>
      )}
    </button>
  );
}
